// Événement GTM « sign_up » : uniquement pour un nouveau compte, une seule fois par compte.
export const pushSignUp = (method, userId) => {
  if (!userId) return;
  const key = `signup_tracked_${userId}`;
  try { if (localStorage.getItem(key)) return; localStorage.setItem(key, "1"); } catch (e) { /* stockage indisponible */ }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "sign_up", method, user_id: String(userId) });
};
